import Vue from 'vue'
import Router from 'vue-router'
import store from './utils/store';

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/login',
    name: 'login',
    component: () => import('./views/Login.vue')
  },
  {
    path: '/',
    name: 'home',
    component: () => import('./views/Home.vue')
  },
  {
    path: '/costcenters',
    name: 'costcenters',
    component: () => import('./views/Costcenters.vue')
  },
  {
    path: '/upload',
    name: 'upload',
    component: () => import('./views/Upload.vue')
  },
  {
    path: '/apportionmentBylocation',
    name: 'apportionmentByLocation',
    component: () => import('./views/LocationApportionment.vue')
  },
  {
    path: '/costcenters/:id',
    name: 'apportionmentByCostcenter',
    component: () => import('./views/ApportionmentByCostcenter.vue')
  },
  {
    path: '/collaborators',
    name: 'collaborators',
    component: () => import('./views/Collaborators.vue')
  },
  {
    path: '/collaborators/:id',
    name: 'apportionmentByCollaborator',
    component: () => import('./views/ApportionmentByCollaborator.vue')
  },
  {
    path: '/apportionment/:id',
    name: 'apportionmentById',
    component: () => import('./views/Apportionment.vue')
  },
  {
    path: '/rules',
    name: 'rulesList',
    component: () => import('./views/RulesList.vue')
  },
  {
    path: '/areas',
    name: 'areaPage',
    component: () => import('./views/AreaPage.vue')
  },
  {
    path: '/users',
    name: 'usersPage',
    component: () => import('./views/UsersPage.vue')
  },
  {
    path: '/rules/:token',
    name: 'rule',
    component: () => import('./views/Rule.vue')
  },
  {
    path: '*',
    name: '404_page',
    component: () => import('./views/404_page.vue')
  }
  ]
})

router.beforeEach((to, from, next) => {

  store.state.pathName = to.path;

  store.dispatch('fetchAccessToken');

  if (to.fullPath === "/") {
    if (!store.state.accessToken) {
      next("/login");
    }
  }
  else if (to.fullPath === "/login") {
    if (store.state.accessToken) {
      next("/");
    }
  }
  else {
    if (!store.state.accessToken) {
      next('/login');
    }
  }
  next();
});

export default router;